export const moveTypeStatus = {
    'PendingStatus': 0,
    'InProgressStatus': 1,
    'CompleteStatus': 2,
    'UpdateStatus': 3
}